import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NbChatModule, NbFocusMonitor, NbLayoutDirectionService, NbMediaBreakpointsService, NbSidebarService, NbStatusService, NbThemeService } from '@nebular/theme';
import { ChatSidemenuComponent } from './chat-sidemenu.component';
import { IonicModule } from '@ionic/angular';

@NgModule({
    declarations: [
        ChatSidemenuComponent, // Declare your component
    ],
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        NbChatModule,
    ],
    providers: [
      NbThemeService,
      NbFocusMonitor,
      NbMediaBreakpointsService,
      NbStatusService,
      NbLayoutDirectionService,
      NbSidebarService,
  ],
    exports: [
        ChatSidemenuComponent, // Export if this component is used elsewhere
    ],
})
export class ChatSidemenuModule {}
